var app = angular.module('leonardo');

var LoginService = function($q, $filter, NavigationService, AuthService,
                            BroadcastChannelService) {
  var service = {};

  service.ERROR_SSO_GENERAL = '0';
  service.ERROR_SSO_IDP_NO_ROLES_NO_PROPERTIES = '1';
  service.ERROR_SSO_IDP_NO_PROPERTIES = '2';
  service.ERROR_SSO_IDP_NO_ROLES = '3';
  service.ERROR_SSO_IDP_PROPERTIES_NOT_FOUND = '4';
  service.ERROR_SSO_IDP_ROLES_NOT_FOUND = '5';
  service.ERROR_SSO_IDP_MULTIPLE_ROLES = '6';
  service.ERROR_SSO_LEO_INACTIVE_USER = '7';
  service.ERROR_SSO_LEO_PROPERTIES_NOT_FOUND = '8';
  service.ERROR_SSO_LEO_ROLES_NOT_FOUND = '9';
  service.ERROR_SSO_CREATE_UPDATE_USER = '10';

  service.ERROR_LOGIN_SUPPORT_MESSAGE = $filter('translate')('Please contact <a href="mailto:help@leonardo247.com" target="_blank">help@leonardo247.com</a> for further assistance.');

  service.ERROR_SSO_OPTIONS = [
    {
      id: service.ERROR_SSO_GENERAL,
      name: $filter('translate')('There was a problem logging into your Leonardo247 user account.'),
      support: service.ERROR_LOGIN_SUPPORT_MESSAGE
    },
    {
      id: service.ERROR_SSO_IDP_NO_ROLES_NO_PROPERTIES,
      name: $filter('translate')('Your Leonardo247 user account is not yet assigned to a Role and/or Property.'),
      support: service.ERROR_LOGIN_SUPPORT_MESSAGE
    },
    {
      id: service.ERROR_SSO_IDP_NO_PROPERTIES,
      name: $filter('translate')('Your Leonardo 247 user account is not yet assigned to a Property.'),
      support: service.ERROR_LOGIN_SUPPORT_MESSAGE
    },
    {
      id: service.ERROR_SSO_IDP_NO_ROLES,
      name: $filter('translate')('Your Leonardo 247 user account is not yet assigned to a Role.'),
      support: service.ERROR_LOGIN_SUPPORT_MESSAGE
    },
    {
      id: service.ERROR_SSO_IDP_PROPERTIES_NOT_FOUND,
      name: $filter('translate')('Your User account is assigned to one or more properties that do not exist in Leonardo247.'),
      support: service.ERROR_LOGIN_SUPPORT_MESSAGE
    },
    {
      id: service.ERROR_SSO_IDP_ROLES_NOT_FOUND,
      name: $filter('translate')('Your User account is assigned to a Role that does not exist in Leonardo247.'),
      support: service.ERROR_LOGIN_SUPPORT_MESSAGE
    },
    {
      id: service.ERROR_SSO_IDP_MULTIPLE_ROLES,
      name: $filter('translate')('Your User account is assigned to more than one Role.'),
      support: service.ERROR_LOGIN_SUPPORT_MESSAGE
    },
    {
      id: service.ERROR_SSO_LEO_INACTIVE_USER,
      name: $filter('translate')('Your User account is Inactive/Disabled.'),
      support: service.ERROR_LOGIN_SUPPORT_MESSAGE
    },
    {
      id: service.ERROR_SSO_LEO_PROPERTIES_NOT_FOUND,
      name: $filter('translate')('Your User account is assigned to one or more properties that do not exist in Leonardo247.'),
      support: service.ERROR_LOGIN_SUPPORT_MESSAGE
    },
    {
      id: service.ERROR_SSO_LEO_ROLES_NOT_FOUND,
      name: $filter('translate')('Your User account is assigned to a Role that does not exist in Leonardo247.'),
      support: service.ERROR_LOGIN_SUPPORT_MESSAGE
    },
    {
      id: service.ERROR_SSO_CREATE_UPDATE_USER,
      name: $filter('translate')('Something went wrong while creating or updating the User account.'),
      support: service.ERROR_LOGIN_SUPPORT_MESSAGE
    },
  ]

  function encryptPassword(password, key) {
    // Generate random IV
    const iv = CryptoJS.lib.WordArray.random(16); // 16 bytes IV
  
    // Encrypt the password
    const encrypted = CryptoJS.AES.encrypt(
      CryptoJS.enc.Utf8.parse(password),
      CryptoJS.SHA256(CryptoJS.enc.Utf8.parse(key)),
      {
        iv: iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7
      }
    );
    // Convert IV and encrypted password to Base64 and concatenate them
    const ivBase64 = CryptoJS.enc.Base64.stringify(iv);
    const encryptedBase64 = encrypted.toString();
    return ivBase64 + encryptedBase64;
  }

  service.login = function(username, password, legal_terms) {
    var defer = $q.defer();
    const key = window.LEO_PE_KEY;
    const encryptedPassword = encryptPassword(password, key);
    AuthService.getToken(username, encryptedPassword, legal_terms).then(function(data) {
      if (AuthService.hasToken()){
        BroadcastChannelService.postMessage({
          type: 'login',
          message: 'User logged in'
        });
        defer.resolve();
        localStorage.setItem('auth_provider', 'leonardo247');
        NavigationService.goToLoginRedirection();
      }
      else {
        if (data.action === 'redirect') {
          window.location.replace(data.url);
        }
      }
    }, function(error) {
      defer.reject(error);
    });
    return defer.promise;
  };

  service.redirect = function(authData) {
    let url_redirect = angular.copy(localStorage.getItem('url_redirect'));
    if (url_redirect) {
      localStorage.removeItem('url_redirect');
      NavigationService.redirectToState(JSON.parse(url_redirect));
      return;
    }
    NavigationService.goToHome(authData);
  };

  service.onBroadcastChannelMessage = function (message) {
    if (!message.type) {
      return;
    }

    switch (message.type) {
      case 'logout':
        NavigationService.goToUserAnonymousHome();
        return;
      case 'login':
        NavigationService.goToLoginRedirection();
        return;
    }
  };

  BroadcastChannelService.subscribe(service);

  return service;
};

app.factory('LoginService', ['$q','$filter', 'NavigationService', 'AuthService', 'BroadcastChannelService', LoginService]);
